import menu from "@ui-components/AppNavigation/menu";
import {MenuEntryBase} from "@ui-components/AppNavigation/types";

export const getMenuPermissions = (countryCode: string) => menu
  .flatMap(
    // Flatten menu items. If an item has `dropdown`, include them as first-level items
    (item) => !!item.dropdown ? item.dropdown as MenuEntryBase[] : [item]
  )
  .reduce((acc, item) => {
    const roles = Array.isArray(item.roles)
      ? item.roles as string[]
      : (item.roles as Record<string, string[]> | undefined)?.[countryCode ?? ""]
    ;
    return {...acc, [item.name]: roles ?? null};
  }, {} as Record<string, string[] | null | "*">);